export const CARD_FEE_LABEL = 'Card Processing Fee';
